/*
 * @Author: masonzhou
 * @Date: 2024-01-31 21:32:41
 * @LastEditTime: 2024-02-04 13:45:03
 * @FilePath: \yl-cjsph-tms-operation-front\src\router\utils.ts
 * @Description:
 */
import {
  createWebHashHistory,
  createWebHistory,
  RouteComponent,
  RouteRecordNormalized,
  RouteRecordRaw,
  RouterHistory
} from 'vue-router';
import { router, constantMenus, resetRouter } from './index';
import { isProxy, toRaw } from 'vue';
import { useTimeoutFn } from '@vueuse/core';
import { RouteConfigs } from '@/layout/types';
import {
  cloneDeep
  // isAllEmpty
} from '@pureadmin/utils';
import { buildHierarchyTree } from '@/utils/tree';
import { usePermissionStoreHook } from '@/store/modules/permission';
``;
// 动态路由
// const IFrame = () => import('@/layout/frameView.vue');
// https://cn.vitejs.dev/guide/features.html#glob-import
const modulesRoutes = import.meta.glob('/src/views/**/*.{vue,tsx}');

// function handRank(routeInfo: any) {
//   const { name, path, parentId, meta } = routeInfo;
//   return isAllEmpty(parentId)
//     ? isAllEmpty(meta?.rank) ||
//         (meta?.rank === 0 && name !== 'Home' && path !== '/')
//     : false;
// }

/** 按照路由中meta下的rank等级升序来排序路由 */
function ascending(arr: any[]) {
  // arr.forEach((v, index) => {
  //   // 当rank不存在时，根据顺序自动创建，首页路由永远在第一位
  //   if (handRank(v)) v.meta.rank = index + 2;
  // });
  return arr;
}

/** 过滤路由中中status不等于1的菜单 */
function filterTree(data: RouteComponent[]) {
  const newTree = cloneDeep(data).filter(
    (v: { status: number; menuType: Number }) =>
      v.status === 1 && v.menuType !== 3
  );
  // 根据 orderNum 字段 排序
  newTree.sort((a: any, b: any) => a.orderNum - b.orderNum);
  newTree.forEach(
    (v: { children: any }) =>
      v.children && (v.children = filterTree(v.children))
  );
  return newTree;
}

function flatTree(list: any[]): Array<RouteConfigsTable> {
  return list.reduce((ls, item) => {
    const { children, ...res } = item;
    const retain = res;
    if (children && children.length) {
      return ls.concat(retain, flatTree(children));
    } else {
      return ls.concat(retain);
    }
  }, []);
}

/** 过滤children长度为0的的目录，当目录下没有菜单时，会过滤此目录，当目录下只要有一个菜单有显示权限，那么此目录就会显示 */
function filterChildrenTree(data: RouteComponent[]) {
  // menuType: 1-目录 2-菜单 3-按钮, 过滤menuTpey为1且children为空的数据
  return cloneDeep(data).filter(
    (v: any) => !(v.menuType === 1 && v?.children?.length === 0)
  );
}

/** 批量删除缓存路由(keepalive) */
function delAliveRoutes(delAliveRouteList: Array<RouteConfigs>) {
  delAliveRouteList.forEach(route => {
    usePermissionStoreHook().cacheOperate({
      mode: 'delete',
      name: route?.name
    });
  });
}

/** 通过path获取父级路径 */
function getParentPaths(path: string, routes: RouteRecordRaw[]) {
  // 深度遍历查找
  function dfs(routes: RouteRecordRaw[], path: string, parents: string[]) {
    for (let i = 0; i < routes.length; i++) {
      const item = routes[i];
      // 找到path则返回父级path
      if (item.path === path) return parents;
      // children不存在或为空则不递归
      if (!item.children || !item.children.length) continue;
      // 往下查找时将当前path入栈
      parents.push(item.path);

      if (dfs(item.children, path, parents).length) return parents;
      // 深度遍历查找未找到时当前path 出栈
      parents.pop();
    }
    // 未找到时返回空数组
    return [];
  }

  return dfs(routes, path, []);
}

/** 查找对应path的路由信息 */
function findRouteByPath(path: string, routes: RouteRecordRaw[]): any {
  let res = routes.find((item: { path: string }) => item.path == path);
  if (res) {
    return isProxy(res) ? toRaw(res) : res;
  } else {
    for (let i = 0; i < routes.length; i++) {
      if (
        routes[i].children instanceof Array &&
        routes[i].children.length > 0
      ) {
        res = findRouteByPath(path, routes[i].children);
        if (res) {
          return isProxy(res) ? toRaw(res) : res;
        }
      }
    }
    return null;
  }
}

function addPathMatch() {
  if (!router.hasRoute('pathMatch')) {
    router.addRoute({
      path: '/:pathMatch(.*)',
      name: 'pathMatch',
      redirect: '/error/404'
    });
  }
}

function processMenuData(data: any) {
  const result: any = [];

  function processChildren(childMenu: any) {
    const children = childMenu.children;
    if (Array.isArray(children) && children.length > 0) {
      const names = children
        .filter((child: any) => child.menuType === 3)
        .map((child: any) => {
          // console.log(childMenu, 'children');
          return { [childMenu.path]: child.moduleType };
        });

      if (names.length > 0) {
        result.push(names);
      }

      children.forEach((child: any) => {
        processChildren(child);
      });
    }
  }

  data.forEach((item: any) => {
    processChildren(item);
  });

  return result;
}

/** 处理动态路由（后端返回的路由） */
function handleAsyncRoutes(routeList: any) {
  if (routeList.length === 0) {
    usePermissionStoreHook().handleWholeMenus(routeList);
  } else {
    try {
      resetRouter();
      const newRouterList = formatFlatteningRoutes(addAsyncRoutes(routeList));
      newRouterList.map((v: any) => {
        // if (v.menuType === 3 || v.status !== 1) {
        //   return false;
        // }
        if (v.status !== 1 || (v.menuType === 3 && !v.component)) {
          return false;
        }
        // 防止重复添加路由
        if (
          router.options.routes[0].children.findIndex(
            value => value.path === v.path
          ) !== -1
        ) {
          return false;
        } else {
          router.options.routes[0].children.push(v);
          // 最终路由进行升序
          if (!router.hasRoute(v?.name) && /^\\/.test(v.path)) {
            router.addRoute(v);
          }
        }
      });
      // console.log(router.options.routes[0]);
      // 切记将路由push到routes后还需要使用addRoute，这样路由才能正常跳转
      router.addRoute(router.options.routes[0]);
      // debugger;
      return new Promise(resolve => {
        usePermissionStoreHook().handleWholeMenus(routeList);
        usePermissionStoreHook().handleBtnList(routeList);
        resolve(router);
      });
    } catch (e) {
      console.log(e);
      usePermissionStoreHook().handleWholeMenus([]);
    }
  }
  addPathMatch();
}

/** 初始化路由（`new Promise` 写法防止在异步请求中造成无限循环）*/
function initRouter() {
  return new Promise(resolve => {
    usePermissionStoreHook().handleWholeMenus([]);
    resolve(router);
  });
}

/**
 * 将多级嵌套路由处理成一维数组
 * @param routesList 传入路由
 * @returns 返回处理后的一维路由
 */
function formatFlatteningRoutes(routesList: RouteConfigsTable[]) {
  if (routesList.length === 0) return routesList;
  let hierarchyList = buildHierarchyTree(routesList);
  for (let i = 0; i < hierarchyList.length; i++) {
    if (hierarchyList[i].children) {
      hierarchyList = hierarchyList
        .slice(0, i + 1)
        .concat(hierarchyList[i].children, hierarchyList.slice(i + 1));
    }
  }
  return hierarchyList;
}

/**
 * 一维数组处理成多级嵌套数组（三级及以上的路由全部拍成二级，keep-alive 只支持到二级缓存）
 * https://github.com/pure-admin/vue-pure-admin/issues/67
 * @param routesList 处理后的一维路由菜单数组
 * @returns 返回将一维数组重新处理成规定路由的格式
 */
function formatTwoStageRoutes(routesList: RouteRecordRaw[]) {
  if (routesList.length === 0) return routesList;
  const newRoutesList: RouteRecordRaw[] = [];
  routesList.forEach((v: RouteRecordRaw) => {
    if (v.path === '/') {
      newRoutesList.push({
        component: v.component,
        name: v.name,
        path: v.path,
        redirect: v.redirect,
        meta: v.meta,
        children: []
      });
    } else {
      newRoutesList[0]?.children.push({ ...v });
    }
  });
  return newRoutesList;
}

/** 处理缓存路由（添加、删除、刷新） */
function handleAliveRoute(matched: RouteRecordNormalized[], mode?: string) {
  switch (mode) {
    case 'add':
      matched.forEach(v => {
        usePermissionStoreHook().cacheOperate({ mode: 'add', name: v.name });
      });
      break;
    case 'delete':
      usePermissionStoreHook().cacheOperate({
        mode: 'delete',
        name: matched[matched.length - 1].name
      });
      break;
    default:
      usePermissionStoreHook().cacheOperate({
        mode: 'delete',
        name: matched[matched.length - 1].name
      });
      useTimeoutFn(() => {
        matched.forEach(v => {
          usePermissionStoreHook().cacheOperate({ mode: 'add', name: v.name });
        });
      }, 100);
  }
}

/** 过滤后端传来的动态路由 重新生成规范路由 */
function addAsyncRoutes(arrRoutes: Array<RouteConfigsTable>) {
  if (!arrRoutes || !arrRoutes.length) return;
  const modulesRoutesKeys = Object.keys(modulesRoutes);
  const routeList = flatTree(constantMenus);
  arrRoutes.forEach((v: RouteConfigsTable) => {
    // 将backstage属性加入meta，标识此路由为后端返回路由
    v.meta.backstage = true;
    // 父级的name属性取值：如果子级存在且父级的name属性不存在，默认取第一个子级的name；如果子级存在且父级的name属性存在，取存在的name属性，会覆盖默认值（注意：测试中发现父级的name不能和子级name重复，如果重复会造成重定向无效（跳转404），所以这里给父级的name起名的时候后面会自动加上`Parent`，避免重复）
    // if (v?.children && v.children.length && !v.redirect)
    //   v.redirect = v.children[0].path;
    if (v?.children && v.children.length && !v.name)
      v.name = (v.children[0].name as string) + 'Parent';
    try {
      // 对后端传component组件路径和不传做兼容（如果后端传component组件路径，那么path可以随便写，如果不传，从路由列表匹配）
      if (v?.component) {
        const index = modulesRoutesKeys.findIndex(ev =>
          ev.includes(v.component as any)
        );
        v.component = modulesRoutes[modulesRoutesKeys[index]];
      } else {
        const index = routeList.findIndex(
          (route: RouteConfigsTable) => route.path === v.path
        );
        if (index !== -1 && v?.menuType === 2) {
          v.component = routeList[index].component;
          console.error(
            `规范路由:: 请务必在菜单管理配置 ${v.path} 的组件路径`,
            v
          );
        }
      }
    } catch (e) {
      console.log(e, '对后端传component组件路径和不传做兼容');
    }
    if (v?.children && v.children.length) {
      addAsyncRoutes(v.children);
    }
  });
  return arrRoutes;
}

/** 获取路由历史模式 https://next.router.vuejs.org/zh/guide/essentials/history-mode.html */
function getHistoryMode(routerHistory: any): RouterHistory {
  // len为1 代表只有历史模式 为2 代表历史模式中存在base参数 https://next.router.vuejs.org/zh/api/#%E5%8F%82%E6%95%B0-1
  const historyMode = routerHistory.split(',');
  const leftMode = historyMode[0];
  const rightMode = historyMode[1];
  // no param
  if (historyMode.length === 1) {
    if (leftMode === 'hash') {
      return createWebHashHistory('');
    } else if (leftMode === 'h5') {
      return createWebHistory('');
    }
  } //has param
  else if (historyMode.length === 2) {
    if (leftMode === 'hash') {
      return createWebHashHistory(rightMode);
    } else if (leftMode === 'h5') {
      return createWebHistory(rightMode);
    }
  }
}

/** 获取当前页面按钮级别的权限 */
function getAuths(): Array<string> {
  return router.currentRoute.value.meta.auths as Array<string>;
}

/** 是否有按钮级别的权限 */
function hasAuth(value: string | Array<string>): boolean {
  if (!value) return false;
  const routeName: any = location.pathname;
  const authList = usePermissionStoreHook().btnList[routeName] || [];
  if (Array.isArray(value)) {
    return value.every(v => {
      return authList.indexOf(v) > -1;
    });
  } else {
    return authList.indexOf(value) > -1;
  }
}

function transformArray(arr: any) {
  const result: any = {};
  arr.forEach((subArr: any) => {
    subArr.forEach((obj: any) => {
      if (typeof obj !== 'object') {
        console.error('Invalid element:', obj);
        return;
      }
      const key = Object.keys(obj)[0];
      const value = obj[key];
      if (!key || !value) {
        console.error('Invalid object:', obj);
        return;
      }
      if (result[key]) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });
  });
  return result;
}

function handleBtnList(data: any) {
  return transformArray(processMenuData(data)); // 处理按钮权限
}

export {
  hasAuth,
  getAuths,
  ascending,
  flatTree,
  filterTree,
  handleBtnList,
  filterChildrenTree,
  initRouter,
  handleAsyncRoutes,
  addPathMatch,
  getHistoryMode,
  addAsyncRoutes,
  delAliveRoutes,
  getParentPaths,
  findRouteByPath,
  handleAliveRoute,
  formatTwoStageRoutes,
  formatFlatteningRoutes
};
